import GroupsDrEvents from './GroupsDrEvents';

export default GroupsDrEvents;
